import { Component } from 'vue-property-decorator'
import { GForm } from '../GForm'

@Component
export class EnablementTaskView extends GForm {

}
